import { apiSlice } from '@/api';
import { UserUpdate, ResetPasswordType, User } from './types';

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    profile: builder.query<User, void>({
      query: () => ({
        url: 'v1/user/profile',
      }),
      transformResponse: (response: { result: User }) => response.result,
    }),
    updatePassword: builder.mutation<any, ResetPasswordType>({
      query: (data) => ({
        url: `v1/user/profile/change-password`,
        method: 'PUT',
        body: data,
      }),
    }),
    updateProfile: builder.mutation<any, UserUpdate>({
      query: (data) => ({
        url: `v1/user/profile`,
        method: 'PATCH',
        body: data,
      }),
    }),
  }),
});

export const {
  useProfileQuery,
  useUpdatePasswordMutation,
  useUpdateProfileMutation,
} = userApiSlice;
